<div class="form-field-group-container"
     [ngClass]="{ 'form-field-group-bordered': bordered }">
  <div class="form-field-group-title">
    <h3>{{label}}</h3>
    <mat-divider *ngIf="!bordered"></mat-divider>
  </div>
  <ng-content></ng-content>
</div>
